import script from "./EditWork.vue?vue&type=script&setup=true&lang=ts"
export * from "./EditWork.vue?vue&type=script&setup=true&lang=ts"

import "./EditWork.vue?vue&type=style&index=0&id=2bbf0f3a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2bbf0f3a"]])

export default __exports__